import styles from "./detail-field.module.scss";
import type { DetailFieldViewModel } from "./types-detail-field";

export function DetailFieldView({
  label,
  testId,
  variant,
  startsRow,
  hint,
  valor,
  href,
}: DetailFieldViewModel) {
  const classes = [styles.field, styles[variant], startsRow ? styles.fieldRowStart : ""];

  return (
    <div className={classes.filter(Boolean).join(" ")}>
      <dt className={styles.label}>{label}</dt>
      <dd className={styles.value} data-testid={testId}>
        {href ? (
          <a className={styles.valueLink} href={href}>
            {valor}
          </a>
        ) : (
          valor
        )}
        {hint ? <span className={styles.hint}> {hint}</span> : null}
      </dd>
    </div>
  );
}
